// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JJsp","top":"styles_top__2sgrB","left":"styles_left__9QSxb","description":"styles_description__1JkVl"};